var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2291 14.791C21.2301 14.791 22.0416 13.9795 22.0416 12.9785C22.0416 11.9775 21.2301 11.166 20.2291 11.166C19.2281 11.166 18.4166 11.9775 18.4166 12.9785C18.4166 13.9795 19.2281 14.791 20.2291 14.791Z",
    fill: "#D1D6D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7709 14.791C12.7719 14.791 13.5834 13.9795 13.5834 12.9785C13.5834 11.9775 12.7719 11.166 11.7709 11.166C10.7699 11.166 9.95837 11.9775 9.95837 12.9785C9.95837 13.9795 10.7699 14.791 11.7709 14.791Z",
    fill: "#D1D6D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9879 3.91602C9.31788 3.91602 3.91663 9.32935 3.91663 15.9993C3.91663 22.6693 9.31788 28.0827 15.9879 28.0827C22.67 28.0827 28.0833 22.6693 28.0833 15.9993C28.0833 9.32935 22.67 3.91602 15.9879 3.91602ZM16 25.666C10.6591 25.666 6.33329 21.3402 6.33329 15.9993C6.33329 10.6585 10.6591 6.33268 16 6.33268C21.3408 6.33268 25.6666 10.6585 25.6666 15.9993C25.6666 21.3402 21.3408 25.666 16 25.666ZM16 20.8327C15.1179 20.8327 14.3325 20.6152 13.6316 20.2043C13.4866 20.3735 12.5925 21.3885 12.4112 21.5939C13.4504 22.2585 14.6708 22.6452 16 22.6452C17.3412 22.6452 18.5616 22.2464 19.6008 21.5818C18.4287 20.2648 19.5887 21.5577 18.3804 20.1923C17.6675 20.6152 16.882 20.8327 16 20.8327Z",
    fill: "#D1D6D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfied);
export default __webpack_public_path__ + "static/media/satisfied.637126f22f7c7f23930c0508a7025dce.svg";
export { ForwardRef as ReactComponent };